module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-900-[6]493.d93975d.woff2";